import React from 'react';
import PropTypes from 'prop-types';
import './draggable-row.scss';

const DraggableRow = ({ children, rowData, isDraggable = true }) => {
  const handleDragStart = (e) => {
    if (!isDraggable) {
      e.preventDefault();
      return;
    }
    e.dataTransfer.setData('application/json', JSON.stringify(rowData));
    e.dataTransfer.effectAllowed = 'move';
  };

  return (
    <tr
      className={`draggable-row ${isDraggable ? 'draggable' : ''}`}
      draggable={isDraggable}
      onDragStart={handleDragStart}
      data-testid="draggable-row"
    >
      {children}
    </tr>
  );
};

DraggableRow.propTypes = {
  children: PropTypes.node.isRequired,
  rowData: PropTypes.object.isRequired,
  isDraggable: PropTypes.bool,
};

export default DraggableRow;
